import { House } from "lucide-react";

interface BrandProps {
  compact?: boolean;
  inverse?: boolean;
}

export function Brand({ compact = false, inverse = false }: BrandProps) {
  return (
    <a className={`brand ${inverse ? "brand--inverse" : ""}`} href="/" aria-label="Alicerce — início">
      <span className="brand__mark" aria-hidden="true">
        <House strokeWidth={2.4} />
        <span />
      </span>
      {!compact && (
        <span className="brand__type">
          <strong>Alicerce</strong>
          <small>decisão imobiliária</small>
        </span>
      )}
    </a>
  );
}

